/**
 * Created by Rodrigo Quesada on 16/01/17.
 */
import {Injectable} from '@angular/core';
import {RepeatableUserModelScreensManager} from '../../../../components/sections/repeatable/repeatable-user-model-screens-manager.service';
import {RepeatableScreensManagerDeps} from '../../../shared/step/repeatable-screen-manager.class';
import {ProfessionalReferenceService} from '../../../../domain/model/reference/professional-reference.service';

@Injectable()
export class ProfessionalReferenceScreensManager extends RepeatableUserModelScreensManager {

    constructor(rsmm: RepeatableScreensManagerDeps, protected readonly _modelService: ProfessionalReferenceService) {
        super(rsmm);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/references/steps/professional/professional-reference-screens-manager.service.ts